import CropsRoutes from './CropsRoutes';

export default CropsRoutes;
